import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../Button/Button";
import CustomSelect from "../CustomSelect/CustomSelect";
import InputBox from "../InputBox/InputBox";
import PreviewBar from "../PreviewBar/PreviewBar";
import { submitSupportRequest } from "../../Redux/support/action";
import "./CreateSupportTicket.css";

const OTHER = "__other__";

// "What's this about?" topics — the selected label becomes the Plane work
// item's subject ("Something else" reveals a free-text field instead).
const TOPIC_OPTIONS = [
  { title: "Locations & procedures", key: "Locations & procedures" },
  { title: "Workforce", key: "Workforce" },
  { title: "Reports", key: "Reports" },
  { title: "Account & access", key: "Account & access" },
  { title: "Technical issue / app bug", key: "Technical issue / app bug" },
  { title: "Something else", key: OTHER }
];

// "Raise a ticket" — mounted at /support/new. Collects a topic + description
// and files a Plane intake work item through the server-side wrapper (Redux
// support saga -> functions/support.js). The signed-in admin's name is sent
// along so support can follow up; uid + phone are added server-side from the
// verified token.
function CreateSupportTicket(props) {
  const navigate = useNavigate();
  const [topic, setTopic] = useState("");
  const [otherTopic, setOtherTopic] = useState("");
  const [description, setDescription] = useState("");

  const subject = topic === OTHER ? otherTopic.trim() : topic;
  const canSubmit =
    Boolean(subject) && Boolean(description.trim()) && !props.submitting;

  const close = () => navigate("/support");

  const submit = () => {
    if (!canSubmit) {
      return;
    }
    submitSupportRequest(
      {
        name: subject,
        description: description.trim(),
        username: props.profile?.data?.name
      },
      (path) => navigate(path, { replace: true })
    );
  };

  return (
    <PreviewBar
      title="New support ticket"
      onCloseClick={close}
      isMobileView={props.isMobileView}
    >
      <CustomSelect
        data-cy="SUPPORT-TOPIC"
        options={TOPIC_OPTIONS}
        placeholder="WHAT'S THIS ABOUT?"
        label="WHAT'S THIS ABOUT?"
        value={topic}
        selected={topic}
        handleSelectedData={(key) => setTopic(key)}
        search={false}
        removeResponsive={true}
        fontColor="font-color-tertiaryColor"
        labelFontColor="font-color-tertiaryColor"
      />

      {topic === OTHER ? (
        <InputBox
          className="inherit-parent-width margin-top-large"
          name="otherTopic"
          label="TELL US THE TOPIC"
          type="text"
          placeholder="e.g. Report export failing"
          removeResponsive={true}
          value={otherTopic}
          onChange={(event) => setOtherTopic(event.target.value)}
          fontColor="font-color-tertiaryColor"
          labelFontColor="font-color-tertiaryColor"
          data-cy="SUPPORT-TOPIC-OTHER"
        />
      ) : null}

      <div className="margin-top-large input-box-border-bottom-default ">
        <div className="font-color-tertiaryColor6 font-size-small margin-bottom-small">
          DESCRIBE THE ISSUE
        </div>
        <textarea
          className="support-description-textarea inherit-parent-width font-color-tertiaryColor background-color-tertiaryColor2 border-radius-default font-size-medium padding-vertical-medium border-none"
          placeholder="What happened? Include any steps that help us reproduce it."
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          data-cy="SUPPORT-DESCRIPTION"
        />
      </div>

      <div className="margin-top-larger">
        <Button
          text="Submit"
          onClick={submit}
          disabled={!canSubmit}
          loading={props.submitting}
          data-cy="SUPPORT-SUBMIT"
        />
      </div>
    </PreviewBar>
  );
}

const mapStateToProps = (state) => ({
  submitting: state.support.submitting,
  profile: state.profile
});

export default connect(mapStateToProps)(CreateSupportTicket);
